import { menuItems } from '../../../mocks/menuItems';

export default function MenuPreview() {
  return (
    <section id="menu" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="mb-12">
          <div className="inline-block px-4 py-1 bg-red-100 text-red-700 rounded-full text-sm font-semibold mb-4">
            Our Menu
          </div>
          <h2 className="text-5xl md:text-6xl font-serif font-bold text-gray-900 mb-4">
            Signature Dishes
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl">
            Every dish is prepared fresh daily with the finest ingredients and authentic recipes passed down through generations.
          </p>
        </div>

        <div className="overflow-x-auto pb-6 -mx-6 px-6">
          <div className="flex gap-6 min-w-max">
            {menuItems.map((item, index) => (
              <div 
                key={index}
                className="w-80 bg-white rounded-3xl shadow-lg hover:shadow-xl transition-all duration-300 overflow-hidden flex-shrink-0 cursor-pointer group"
              >
                <div className="relative h-80 overflow-hidden">
                  <img 
                    src={item.image} 
                    alt={item.name}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  />
                </div>
                <div className="p-6">
                  <div className="text-xs uppercase tracking-wider text-red-700 font-semibold mb-2">
                    {item.category}
                  </div>
                  <h3 className="text-2xl font-serif font-bold text-gray-900 mb-3">
                    {item.name}
                  </h3>
                  <p className="text-sm text-gray-600 mb-4 line-clamp-2 leading-relaxed">
                    {item.description}
                  </p>
                  <div className="flex items-center justify-between">
                    <span className="text-3xl font-bold text-gray-900">
                      ${item.price}
                    </span>
                    <button className="w-10 h-10 flex items-center justify-center bg-red-700 text-white rounded-full hover:bg-red-800 transition-colors">
                      <i className="ri-add-line text-xl"></i>
                    </button>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="text-center mt-12">
          <a href="#menu" className="inline-flex items-center gap-2 text-red-700 font-semibold hover:gap-3 transition-all cursor-pointer">
            View Full Menu
            <i className="ri-arrow-right-line"></i>
          </a>
        </div>
      </div>
    </section>
  );
}